export { DismissibleAdblockDialog } from './DismissibleAdblockDialog/DismissibleAdblockDialog.tsx';
export { NonDismissibleAdblockOverlay } from './NonDismissibleAdblockOverlay/NonDismissibleAdblockOverlay.tsx';
export const DISABLE_ADBLOCK_DIALOG_VARIANTS = [
    'dismissible',
    'nondismissible'
];
